import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';

const generateQuotationPDF = async (quotationData, pieCharts, logoUrl) => {
    const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
    let yPos = 20;

    // Add Logo
    const img = new Image();
    img.src = 'https://marzdev.yourcrm.co.za/HeaderLogo.png';
    await new Promise(resolve => {
        img.onload = resolve;
    });
    doc.addImage(img, 'PNG', 120, 10, 80, 20); // Logo positioned at top-left

    // Title
    doc.setFontSize(18);
    doc.text("Quotation Report", 10, yPos + 10);
    yPos += 20;

    // Customer Details and Care Plan Activities in Two Columns
    let startX1 = 10;
    let startX2 = 110;

    // Customer Details Table
    doc.autoTable({
        startY: yPos,
        margin: { left: startX1 },
        head: [["Customer Details", "Value"]],
        body: [
            ["Customer", quotationData.CustomerName],
            ["Report Date", quotationData.ReportDate],
            ["Total Monthly Fee", `R${quotationData.TotalMonthlyFee}`],
            ["Discount", `${quotationData.CustomerDiscount}%`],
            ["Final Quoted Price", `R${quotationData.FinalQuotedPrice}`],
        ],
        theme: 'grid',
        tableWidth: 90
    });

    // Care Plan Activities Table
    doc.autoTable({
        startY: yPos,
        margin: { left: startX2 },
        head: [["Care Plan Activities"]],
        body: quotationData.CarePlanActivities.map(activity => [activity]),
        theme: 'grid',
        tableWidth: 90
    });

    yPos = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 10;

    // Quoted Services Table
    doc.autoTable({
        startY: yPos,
        head: [["Quoted Services", "Fee (R)"]],
        body: quotationData.QuotedServices.length > 0
            ? quotationData.QuotedServices.map(service => [service.name, service.fee])
            : [["No Services Quoted", ""]],
        theme: 'grid'
    });
    yPos = doc.lastAutoTable.finalY + 20;

    const stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
    };

    if (quotationData.AdditionalNotes) {
        const cleanNotes = stripHtml(quotationData.AdditionalNotes);
        doc.setFontSize(12);
        doc.text("Additional Notes", 10, yPos + 10);
        doc.setFontSize(10);
        doc.text(cleanNotes, 10, yPos + 20, { maxWidth: 180 }); // Ensure text wraps
        yPos += 50;
    }
    // Signature Section (Always on the same page as Quoted Services)
    doc.setFontSize(14);
    doc.text("Signatures", 14, yPos);
    yPos += 10;
    doc.setFontSize(12);
    doc.text("Client Name: ____________________________________________    Date: ____________", 14, yPos);
    yPos += 10;
    doc.text("Company Representative Name: ____________________________    Date: ____________", 14, yPos);

    // Move to a new page for Charts
    // doc.addPage();
    // let chartYPos = 20;
    // const chartTitles = [
    //     "Service Breakdown",
    //     "Total Senior Nurse Hours per Day",
    //     "Total Enrolled Nurse Hours per Day",
    //     "Total Care Worker Hours per Day",
    //     "Benefits Breakdown"
    // ];

    // let xPos = 10;
    // let chartWidth = 90;
    // let chartHeight = 70;
    // let rowCount = 0;

    // for (let i = 0; i < pieCharts.length; i++) {
    //     if (rowCount === 2) { // Move to a new row after two charts
    //         xPos = 10;
    //         chartYPos += chartHeight + 20;
    //         rowCount = 0;
    //     }

    //     doc.setFontSize(12);
    //     doc.text(chartTitles[i] || "Chart", xPos + 10, chartYPos);
    //     chartYPos += 6;

    //     const canvas = await html2canvas(pieCharts[i]);
    //     const imgData = canvas.toDataURL("image/png");
    //     doc.addImage(imgData, 'PNG', xPos, chartYPos, chartWidth, chartHeight);

    //     xPos += chartWidth + 10;
    //     rowCount++;
    // }

    // // Save the PDF
    // doc.save(`Quotation_${quotationData.CustomerName}.pdf`);
};

export default generateQuotationPDF;
